<!-- 顶部LOGO、搜索栏、导航栏组件 -->
<template>
  <div>
    <div class="image-container">
      <img :src="src">
    </div>
  </div>
</template>

<script>
export default {
  name: 'aniImg',
  inject: ['reload'],
  // type:不存在代表背景不透明,存在代表透明
  props: ["src"],
  data() {
    return {

    };
  },
  methods: {

  },
  mounted() {

  }
};
</script>

<style scoped lang='scss'>
.image-container {
  overflow: hidden;
  transition: transform 0.3s ease;
}

.image-container img {
  width: 100%;
  height: 100%;
  padding-bottom: 5em ;
  object-fit: cover;
  transition: transform 0.6s ease;

  // &:hover{
  //   transform: scale(1.2);
  // }
}
</style>



// WEBPACK FOOTER //
// src/components/aniImg.vue